import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { ArrowRight, ArrowLeft, Loader2 } from "lucide-react";

export const MobileActionBar = ({ step, quickRange, step1Valid, quickLoading, loading, uploading, canSubmit, onBack, onQuickRange, onGotoStep2, onGotoStep3 }) => {
  const { t } = useLang();

  return (
    <div
      data-testid="mobile-action-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t-2 border-black p-3 flex gap-3"
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      {step > 1 && (
        <button type="button" data-testid="mobile-back-btn" onClick={onBack} className="h-12 w-12 flex-shrink-0 border border-black bg-white flex items-center justify-center active:bg-[#F5F5F5]">
          <ArrowLeft size={20} />
        </button>
      )}
      {step === 1 && !quickRange && (
        <button type="button" data-testid="mobile-primary-btn" onClick={onQuickRange} disabled={!step1Valid || quickLoading} className="h-12 flex-1 bg-[#0A0A0A] text-white font-display font-black tracking-tight flex items-center justify-center gap-2 disabled:opacity-50">
          {quickLoading ? <Loader2 size={18} className="animate-spin" /> : (<>{t.valuator.quick_range_btn} <ArrowRight size={16} /></>)}
        </button>
      )}
      {step === 1 && quickRange && (
        <button type="button" data-testid="mobile-goto-step-2" onClick={onGotoStep2} className="h-12 flex-1 bg-[#FFCC00] text-black font-display font-black tracking-tight flex items-center justify-center gap-2">
          {t.valuator.more_precise} <ArrowRight size={16} />
        </button>
      )}
      {step === 2 && (
        <button type="button" data-testid="mobile-goto-step-3" onClick={onGotoStep3} className="h-12 flex-1 bg-[#0A0A0A] text-white font-display font-black tracking-tight flex items-center justify-center gap-2">
          {t.valuator.step_next} <ArrowRight size={16} />
        </button>
      )}
      {step === 3 && (
        <button type="submit" data-testid="mobile-submit-btn" disabled={loading || uploading || !canSubmit} className="h-12 flex-1 bg-[#0A0A0A] text-white font-display font-black tracking-tight flex items-center justify-center gap-2 disabled:opacity-50">
          {loading ? (<><Loader2 size={18} className="animate-spin" /> {t.valuator.calculating}</>) : (<>{t.valuator.submit} <ArrowRight size={16} /></>)}
        </button>
      )}
    </div>
  );
};

export default MobileActionBar;
